import { ReqModel } from "src/app/shared/models/bases/base-req.model";

class Body {
    merchantApplicationNo: string;
}

export class PME0612Req extends ReqModel {
  constructor() {
    super();
  }
  public body = new Body();
}
